import { env } from "@/env/client"

export function BreakpointIndicator() {
  if (!env.NEXT_PUBLIC_DEVELOPMENT_MODE) return null

  return (
    <div
      className="dark fixed right-[24px] bottom-[-2px] z-2147483647! flex h-[17px] w-[28px] items-center justify-center rounded-t-[8px] bg-black/80 pb-px font-medium font-mono text-[10px] text-foreground uppercase backdrop-blur-2xl"
      style={{
        boxShadow:
          "0 0 0 1px #171717, inset 0 0 0 1px hsla(0,0%,100%,0.14), 0px 16px 32px -8px rgba(0,0,0,0.24)",
      }}
    >
      <div className="block sm:hidden">xs</div>
      <div className="hidden sm:block md:hidden">sm</div>
      <div className="hidden md:block lg:hidden">md</div>
      <div className="hidden lg:block xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  )
}
